export class SalientIndex {
  private type: string;
  private data: number[];
  private sliceIndex: string;

  constructor(type: string, data: number[], sliceIndex: string) {
    this.type = type;
    this.data = data;
    this.sliceIndex = sliceIndex;
  }

  public getType(): string {
    return this.type;
  }

  public getData(): number[] {
    return this.data;
  }

  public getSliceIndex(): string {
    return this.sliceIndex;
  }
}
